import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const updateCounsellor = createAsyncThunk(
  "api/fetchData",
  async (userData, { rejectWithValue }) => {
    const raw = JSON.stringify({
      status: userData.status,
    });
    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/counsellor/` + userData.id,

        raw,
        config
      );
      let status = "success";
      let data = {
        status: status,
        message: response,
      };
      return data;
    } catch (error) {
      let status = "error";
      let data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data;
    }
  }
);

const updateCounsellorSlice = createSlice({
  name: "api",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateCounsellor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCounsellor.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateCounsellor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default updateCounsellorSlice.reducer;
